export default Object.freeze({
    COLLECTION: '3',
    CATEGORY: '5',
    MENU: '7'
})